import { render, staticRenderFns } from "./assistantReplace.vue?vue&type=template&id=fb407e00&"
import script from "./assistantReplace.vue?vue&type=script&lang=js&"
export * from "./assistantReplace.vue?vue&type=script&lang=js&"
import style0 from "./assistantReplace.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports